

function BurgerMenu({
  isOpen = false,
  navItems = [],
  currentPath = '/',
  onNavigate = () => {},
  onClose = () => {},
}) {
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const panelWidth = typeof window !== 'undefined' && window.innerWidth >= 1024 ? '380px' : '88vw';

  return (
    <div
      aria-hidden={!isOpen}
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        display: 'flex',
        justifyContent: 'flex-start',
        background: isOpen ? 'rgba(0, 0, 0, 0.52)' : 'rgba(0, 0, 0, 0)',
        backdropFilter: isOpen ? 'blur(6px)' : 'blur(0px)',
        pointerEvents: isOpen ? 'auto' : 'none',
        opacity: isOpen ? 1 : 0,
        transition: 'opacity 240ms ease, background 240ms ease, backdrop-filter 240ms ease',
      }}
    >
      <aside
        role="dialog"
        aria-modal="true"
        aria-label="Site navigation menu"
        style={{
          width: panelWidth,
          maxWidth: '420px',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          background: 'linear-gradient(180deg, rgba(12,16,24,0.98) 0%, rgba(16,22,32,0.98) 100%)',
          borderRight: '1px solid rgba(255,255,255,0.08)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.45)',
          transform: isOpen ? 'translateX(0)' : 'translateX(-105%)',
          transition: 'transform 280ms cubic-bezier(0.22, 1, 0.36, 1)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            padding: '18px 18px 14px',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span
              style={{
                fontSize: '1.05rem',
                fontWeight: 800,
                letterSpacing: '0.02em',
                color: '#ffffff',
              }}
            >
              CarbCareUSA
            </span>
            <span
              style={{
                marginTop: '2px',
                fontSize: '0.75rem',
                color: 'rgba(255,255,255,0.68)',
              }}
            >
              Parts, support, and carb tools
            </span>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label="Close navigation menu"
            style={{
              minWidth: '44px',
              minHeight: '44px',
              border: 'none',
              borderRadius: '12px',
              cursor: 'pointer',
              background: 'rgba(255,255,255,0.08)',
              color: '#ffffff',
              fontSize: '1.15rem',
              fontWeight: 700,
            }}
          >
            ✕
          </button>
        </div>

        <div
          style={{
            padding: '16px 14px 14px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            overflowY: 'auto',
            flex: 1,
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '10px',
              marginBottom: '8px',
            }}
          >
            <button
              type="button"
              onClick={() => {
                onNavigate('/products');
                onClose();
              }}
              style={{
                minHeight: '50px',
                borderRadius: '14px',
                background: 'rgba(79,163,255,0.14)',
                color: '#ffffff',
                fontWeight: 700,
              }}
            >
              Shop Parts
            </button>
            <button
              type="button"
              onClick={() => {
                onNavigate('/carb-finder');
                onClose();
              }}
              style={{
                minHeight: '50px',
                borderRadius: '14px',
                background: 'linear-gradient(135deg, #1f6feb, #4fa3ff)',
                color: '#ffffff',
                fontWeight: 800,
                boxShadow: '0 10px 24px rgba(31,111,235,0.28)',
              }}
            >
              Carb Finder
            </button>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {navItems.map((item) => {
              const isActive = currentPath === item.path;

              return (
                <button
                  key={item.path}
                  type="button"
                  onClick={() => {
                    onNavigate(item.path);
                    onClose();
                  }}
                  aria-current={isActive ? 'page' : undefined}
                  style={{
                    width: '100%',
                    minHeight: '54px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    padding: '14px 16px',
                    border: isActive
                      ? '1px solid rgba(79,163,255,0.34)'
                      : '1px solid rgba(255,255,255,0.08)',
                    borderRadius: '14px',
                    background: isActive
                      ? 'rgba(79,163,255,0.14)'
                      : 'rgba(255,255,255,0.04)',
                    color: '#ffffff',
                    fontSize: '0.98rem',
                    fontWeight: isActive ? 800 : 600,
                    textAlign: 'left',
                    cursor: 'pointer',
                    transition: 'transform 180ms ease, background 180ms ease, border-color 180ms ease',
                  }}
                >
                  <span>{item.label}</span>
                  <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }}>›</span>
                </button>
              );
            })}
          </div>

          <div
            style={{
              marginTop: '14px',
              padding: '16px',
              borderRadius: '16px',
              background: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.07)',
            }}
          >
            <div style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.62)', marginBottom: '6px' }}>
              Need help fast?
            </div>
            <div style={{ fontSize: '1rem', fontWeight: 800, color: '#ffffff', marginBottom: '8px' }}>
              Talk to CarbCareUSA
            </div>
            <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.76)', marginBottom: '14px' }}>
              Call us for fitment, rebuild questions, or help finding the right carburetor.
            </div>
            <button
              type="button"
              onClick={() => window.open('tel:+16197611113', '_self')}
              style={{
                width: '100%',
                minHeight: '50px',
                borderRadius: '14px',
                background: '#ffffff',
                color: '#0f1115',
                fontWeight: 800,
              }}
            >
              Call +1 (619) 761-1113
            </button>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default BurgerMenu;